<script>
import {useRoute} from "vue-router";
import Icon from "../../components/Icon.vue";

export default {
  name: "ColorListPicker",
  components: {Icon},
  props: {
    modelValue: { // Prop for v-model to be updated
      default: '',
      type: [Number, String, null]
    },
    colorOptions: {
      type: Array, // List of Hex colors or css gradients
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup() {

  },
  methods: {
    onColorSelected(color) {
      this.$emit('update:modelValue', color); // clears the image selection
    }
  }
};
</script>

<template>
  <div class="image-picker-wrapper">
    <div
      class="grid grid-cols-3 gap-2 mt-4"
    >
      <div
        v-for="color in colorOptions"
        class="image-wrapper"
      >
        <div
          class="color-card"
          :class="[{'selected': modelValue === color}]"
          :style="'background: ' + color"
          @click="onColorSelected(color)"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.image-wrapper {
  position: relative;
  height: 100px;
}

.color-card {
  width: 100%;
  height: 100%;
  transition: transform 0.1s cubic-bezier(.59,1.39,.37,1.01), z-index 0.1s cubic-bezier(.59,1.39,.37,1.01);
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;

  &.selected {
    border: 2px solid white;
  }
}

.image-wrapper:hover img {
  transform: scale(1.5);
  z-index: 10;
}
</style>
